import { VIRTUAL_MARKER } from 'components/tables/list-table/filterUtil';
import { DateBasis, ReportEntry } from './reportCatalog';
import { DATE_BASIS_SELECTOR } from './reportFilters';

/**
 * The date the report's period bounds now. The list keeps its `dateBasis` clause in the URL's `mf`, or in `qf` when
 * the quick filter set it; with neither, or with a date the report does not offer, the report's default applies,
 * as its backend reads it. A report with no period has none.
 */
export function selectedDateBasis(
    report: Pick<ReportEntry, 'dateBases'>,
    searchParams: URLSearchParams
): DateBasis | undefined {
    const prefix = `${DATE_BASIS_SELECTOR}==`;
    const clause = [searchParams.get('mf'), searchParams.get('qf')]
        .flatMap((part) => part?.split(';') ?? [])
        .map((each) => (each.startsWith(VIRTUAL_MARKER) ? each.slice(VIRTUAL_MARKER.length) : each))
        .find((each) => each.startsWith(prefix));
    const value = clause?.slice(prefix.length).replace(/^\((.*)\)$/, '$1');
    return report.dateBases.find((each) => each === value) ?? report.dateBases[0];
}
